/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface WebappSettingsDto {
  machinePathLength?: number;
  showDirection?: boolean;
  showEvents?: boolean;
  showFields?: boolean;
  showLocations?: boolean;
  showOfflineMachines?: boolean;
}
